// extracted by mini-css-extract-plugin
module.exports = {"container":"Announcement_container__23W1n"};